<ngx-loading [show]="loading" [config]="{backdropBorderRadius: '14px'}"></ngx-loading>
<h2 mat-dialog-title class="bgDialogHeader text-center">Work Order Details
  <div class="pull-right">
    <a class="boxclose" (click)="onNoClick()"></a>
  </div>
</h2>
<mat-dialog-content class="mat-typography">
  <div class="row">
    <div class="col-md-12 das-table pt-2">
      <table *ngIf="showPendingTable" class="table table-bordered table-hover table-scroll">
        <thead>
          <tr class="wordwrap das-table-row das-table-title">
            <th>WO#</th>
            <th>WO Status</th>
            <th>Pending (Mins)</th>
            <th>Customer</th>
            <th>Submitted</th>
            <th>Service</th>
            <th>Complaint</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let item of pendingTableData">
            <tr *ngIf="checkIsDemo">
              <td class="wordwrap">
                {{item.wONumber}}
                <i class="cursor ml-2 mr-2 fa fa-info-circle" nbTooltip="View Details" aria-hidden="true"
                (click)="viewDetails(item.wONumber)"></i>
                <i nbTooltip="View Notes" class="cursor fa fa-sticky-note ml-2" (click)="viewNotes(item.wONumber)"
                aria-hidden="true"></i>
              </td>
              <td>{{item.wOStatus}}</td>
              <td>{{item.pendingMins}}</td>
              <td>{{item.customerName}}</td>
              <td>{{item.wODate | timezoneConvertDate}}</td>
              <td>{{item.serviceName}}</td>
              <td>
                <pre>{{item.complaint}}</pre>
              </td>
            </tr>
            <tr *ngIf="data.barSelected == 1">
              <td class="wordwrap">{{item.wONumber}}
                <i class="cursor ml-2 mr-2 fa fa-info-circle" nbTooltip="View Details" aria-hidden="true"
                  (click)="viewDetails(item.wONumber)"></i>
                <i nbTooltip="View Notes" class="cursor fa fa-sticky-note ml-2" (click)="viewNotes(item.wONumber)"
                aria-hidden="true"></i>
              </td>
              <td>{{item.wOStatus}}</td>
              <td>{{item.pendingMins}}</td>
              <td>{{item.customerName}}</td>
              <td>{{item.wODate | timezoneConvertDate}}</td>
              <td>{{item.serviceName}}</td>
              <td>
                <pre>{{item.complaint}}</pre>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>

      <table *ngIf="showCompleteVerifyTable" class="table table-bordered table-hover table-scroll">
        <thead>
          <tr class="das-table-row das-table-title">
            <th>WO#</th>
            <th>External AssetId</th>
            <th>Description</th>
            <th>Submitted Date</th>
            <th>Maint Plan</th>
            <th>Status</th>
            <th>As Of</th>
            <th>Current DownTime (Days)</th>
            <th>Expected Down Time (Days)</th>
            <th>WO Total Amt</th>
            <th>Event Note</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of WOTableData">
            <td>{{item.wONumber}}
              <span *ngIf="item.isClonedWO == 1" Class="text-danger">*</span>
              <i class="cursor ml-2 fa fa-info-circle" nbTooltip="View Details" aria-hidden="true"
                (click)="viewDetails(item.wONumber)"></i>
              <i nbTooltip="View Notes" (click)="viewNotes(item.wONumber)" class="cursor fa fa-sticky-note ml-2"
                aria-hidden="true"></i></td>
            <td>{{item.tSQExternalAssetId}}</td>
            <td>{{item.assetDescription}}</td>
            <td>{{item.wODate | timezoneConvertDate}}</td>
            <td>{{item.maintPlan}}</td>
            <td>{{item.wOStatus}}</td>
            <td>{{item.asOf | timezoneConvertDate}}</td>
            <td>{{item.wOCurrentDT}}</td>
            <td>{{item.wOExpectedDT}}</td>
            <td>{{item.wOTotalCost}}</td>
            <td>{{item.wONote}}</td>
          </tr>
        </tbody>
      </table>

    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button (click)="onNoClick()" class="btn btn-success btn-semi-round btn-demo bgBlue pull-right"> Close </button>
</mat-dialog-actions>
